import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=48d9d334&scoped=true&"
import script from "./Collapse.vue?vue&type=script&lang=js&"
export * from "./Collapse.vue?vue&type=script&lang=js&"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=48d9d334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d9d334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d9d334')) {
      api.createRecord('48d9d334', component.options)
    } else {
      api.reload('48d9d334', component.options)
    }
    module.hot.accept("./Collapse.vue?vue&type=template&id=48d9d334&scoped=true&", function () {
      api.rerender('48d9d334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/transport/Collapse.vue"
export default component.exports